export const getAllEmailTemplateNames = `
  query getAllEmailTemplateNames($templateTypes: [String!], $searchText: String) {
    emailTemplates(templateTypes: $templateTypes, searchText: $searchText) {
      emailTemplates {
        id
        name
      }
    }
  }
`;

export interface GetAllEmailTemplateNamesResponse {
  emailTemplates: {
    emailTemplates: {
      id: string;
      name: string;
    }[];
  };
}
